import { orderAPI, myPageAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';
import {
  createLocalMyOrderFixtures,
  findLocalChatUiFixtureOrder,
  isLocalChatUiFixtureEnabled,
  isLocalChatUiFixtureOrderNo
} from '@/views/chat/__fixtures__/chatUiFixture';

const { order_list, order_delete, order_detail } = myPageAPI;

export default {
  async fetchLastBestOrderList({ state, commit, rootGetters }, payload) {
    const { page, totalPage } = state.lastBest;
    if (page > totalPage) return;

    const { main = false } = payload;

    const { latitude, longitude } = rootGetters['user/getUserPosition'];
    const { data, status } = await ServiceExec.get(
      orderAPI.lastBestOrderList,
      {
        page,
        limit: main ? 3 : 10,
        latitude,
        longitude,
        main
      },
      { ...payload }
    );

    if (status !== 200) return;
    const { list, pageInfo } = data;

    // 마트, 마켓 category 상점 제외
    // const filteredList = list.filter((item) => {
    //   return !item.store?.storeCategoryList.some((e) => e.categoryKr.includes('마트') || e.categoryKr.includes('마켓'));
    // });

    commit('setLastBestOrderList', list);
    commit('setLastBestOrderPage', page + 1);
    commit('setLastBestOrderTotalPage', pageInfo.totalPage ?? 2);
    return data;
  },

  async getDetail({ commit, rootGetters }, orderNo) {
    if (isLocalChatUiFixtureEnabled() && isLocalChatUiFixtureOrderNo(orderNo)) {
      // LOCAL UI FIXTURE: resolve fixture detail locally without an order REST read.
      const currentUser = rootGetters['user/getUserData'] ?? {};
      const fixtureOrder = findLocalChatUiFixtureOrder(orderNo, currentUser);
      commit('setDetail', fixtureOrder ?? {});
      return fixtureOrder;
    }

    const { data, status } = await ServiceExec.get(order_detail(orderNo));
    if (status === 200) commit('setDetail', data);
  },

  async negoDeliveryFee({ state, commit }, payload) {
    const { status } = await ServiceExec.patch('/api/order/nego', payload);
    return ServiceExec.status.OK === status;
  },

  FETCH_ORDER_LIST: async ({ state, commit, rootGetters }, userNo) => {
    if (isLocalChatUiFixtureEnabled()) {
      // LOCAL UI FIXTURE: expose only retained fixture orders and terminate pagination locally.
      const currentUser = rootGetters['user/getUserData'] ?? {};
      const fixtureOrders = createLocalMyOrderFixtures(currentUser);
      commit('setMyOrderFixtureList', fixtureOrders);
      commit('setMyOrderPageInfo', {
        page: 2,
        totalPage: 1,
        limit: Math.max(fixtureOrders.length, 1)
      });
      return fixtureOrders;
    }

    const { page, totalPage } = state.myOrder.pageInfo;
    if (page > totalPage) return;

    const { data, status } = await ServiceExec.get(order_list, {
      userNo,
      page: page
    });

    if (status === ServiceExec.status.OK) {
      const { list, pageInfo } = data;

      commit('setMyOrderList', list);
      commit('setMyOrderPageInfo', pageInfo);
      commit('setMyOrderPage', page + 1);
    }
  },

  DELETE_ORDER: async ({ status, commit }, orderNo) => {
    if (isLocalChatUiFixtureEnabled() && isLocalChatUiFixtureOrderNo(orderNo)) {
      // LOCAL UI FIXTURE: fixture deletion is intentionally unsupported and never reaches REST.
      return false;
    }

    const { data } = await ServiceExec.delete(order_delete(orderNo));
    return data;
  }
};
